import { useState } from 'react';
import { FiHome, FiTrendingUp, FiUsers } from 'react-icons/fi';

import { Footer } from '../../components/Footer';
import { Header } from '../../components/Header';
import { ScrollProps } from '../../components/AdvancedSearch';
import logoWhite from '../../assets/redesign/images/logo-white.png';
import logo from '../../assets/redesign/images/logo.png';
import logoCapacete from '../../assets/redesign/images/logo-capacete.png';
import buildingImage from '../../assets/redesign/images/building.png';
import salaoImobiliario from '../../assets/redesign/images/salao-imobiliario.png';
import mutiraoCasaPropria from '../../assets/redesign/images/mutirao-casa-propria.png';
import litoralize from '../../assets/redesign/images/litoralize.png';
import zecazinha from '../../assets/redesign/images/zecazinha.png';
import quemSomos from '../../assets/redesign/images/quem-somos.png';
import missao from '../../assets/redesign/images/missao.jpg';
import visao from '../../assets/redesign/images/visao.jpg';
import valores from '../../assets/redesign/images/valores.jpg';
import {
  Container,
  HeroBand,
  HeroCard,
  HeroTitle,
  HighlightRow,
  LogoTile,
  MarketGrid,
  MarketSection,
  MvvCard,
  MvvGrid,
  MvvSection,
  NumberItem,
  NumbersRow,
  NumbersSection,
  ProjectLogo,
  ProjectsBadge,
  ProjectsBox,
  ProjectsCol,
  QuemImage,
  QuemMedia,
  QuemSomos,
  QuemText,
  StatItem,
  StatsBox,
  StatsCol,
} from './styles';

export default function Sobre() {
  const [search, setSearch] = useState('');
  const [scrollTop, setScrollTop] = useState<ScrollProps>({
    y: 0,
    lastY: 0,
  } as ScrollProps);
  const [show, setShow] = useState(false);

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const y = event.currentTarget.scrollTop;
    setScrollTop((prev) => ({ y, lastY: prev.y }));
  };

  return (
    <Container onScroll={handleScroll}>
      <Header
        show={show}
        setShow={setShow}
        scroll={scrollTop}
        search={search}
        setSearch={setSearch}
      />

      <HeroBand>
        <HeroTitle>
          O maior HUB imobiliário <br /> do Norte e Nordeste
        </HeroTitle>
        <HeroCard>
          <img className="logo" src={logoWhite} alt="Logo" />
          <p>
            Complexo de inteligência e tecnologia imobiliária <br /> Atuando no
            mercado imobiliário desde 2014
          </p>
          <img className="building" src={buildingImage} alt="Imóvel" />
        </HeroCard>

        <MarketSection>
          <h4>O MERCADO ACONTECE AQUI</h4>
          <MarketGrid>
            <ProjectsCol>
              <ProjectsBadge>
                <p>Projetos de Venda</p>
              </ProjectsBadge>
              <ProjectsBox>
                <ProjectLogo>
                  <img src={salaoImobiliario} alt="Salão Imobiliário" />
                </ProjectLogo>
                <ProjectLogo>
                  <img src={mutiraoCasaPropria} alt="Mutirão Casa Própria" />
                </ProjectLogo>
                <ProjectLogo>
                  <img src={litoralize} alt="Litoralize" />
                </ProjectLogo>
                <ProjectLogo>
                  <img src={zecazinha} alt="Zeca Zinha" />
                </ProjectLogo>
              </ProjectsBox>
            </ProjectsCol>

            <StatsCol>
              <StatsBox>
                <StatItem>
                  <h4>16</h4>
                  <p>Imobiliárias</p>
                </StatItem>
                <StatItem>
                  <h4>55</h4>
                  <p>Equipes</p>
                </StatItem>
                <StatItem>
                  <h4>794</h4>
                  <p>Corretores</p>
                </StatItem>
              </StatsBox>
              <HighlightRow>
                <span />
                <p>
                  Imobiliária de destaque no Recife, especializada na venda de
                  lançamentos, apartamentos na planta e imóveis do programa
                  Minha Casa Minha Vida na região.
                </p>
              </HighlightRow>
            </StatsCol>
          </MarketGrid>
        </MarketSection>
      </HeroBand>

      <QuemSomos>
        <QuemText>
          <h4>Quem somos?</h4>
          <p className="wide">
            O Hub Nogueira é mais que uma imobiliária. Somos um ecossistema de
            soluções para o mercado imobiliário, com DNA inovador e atuação
            forte no litoral, econômico, médio/alto padrão e imóveis prontos
            para morar. Unimos inteligência de mercado, times altamente
            especializados e uma cultura de alta performance - sempre de olho no
            futuro.
          </p>
          <p className="narrow">
            Atuamos em parceria com as maiores construtoras do país e oferecemos
            experiências completas: do lançamento à entrega das chaves, com
            excelência comercial, tecnologia, crédito e marketing.
          </p>
        </QuemText>
        <QuemMedia>
          <LogoTile>
            <img src={logo} alt="Logo" />
          </LogoTile>
          <QuemImage src={quemSomos} alt="Quem somos?" />
        </QuemMedia>
      </QuemSomos>

      <NumbersSection>
        <h4>Nossos números</h4>
        <NumbersRow>
          <NumberItem>
            <FiHome />
            <div>
              <h4>+12.000</h4>
              <p>Imóveis comercializados</p>
            </div>
          </NumberItem>
          <NumberItem>
            <FiUsers />
            <div>
              <h4>+8.000</h4>
              <p>Corretores parceiros</p>
            </div>
          </NumberItem>
          <NumberItem>
            <FiTrendingUp />
            <div>
              <h4>+3,5 Bi</h4>
              <p>Em VGV movimentado</p>
            </div>
          </NumberItem>
        </NumbersRow>
      </NumbersSection>

      <MvvSection>
        <img src={logoCapacete} alt="Logo Capacete" />
        <MvvGrid>
          <MvvCard $span $image={missao}>
            <div className="bg" aria-hidden />
            <div className="overlay" aria-hidden />
            <div className="content">
              <h4>Missão</h4>
              <p>
                Conectar pessoas aos melhores imóveis com inteligência,
                confiança e excelência em cada etapa do processo.
              </p>
            </div>
          </MvvCard>
          <MvvCard $image={valores}>
            <div className="bg" aria-hidden />
            <div className="overlay" aria-hidden />
            <div className="content">
              <h4>Valores</h4>
              <p>
                Ser a maior referência em soluções imobiliárias do Nordeste e o
                ecossistema mais completo e desejado do mercado.
              </p>
            </div>
          </MvvCard>
          <MvvCard $image={visao}>
            <div className="bg" aria-hidden />
            <div className="overlay" aria-hidden />
            <div className="content">
              <h4>Visão</h4>
              <ul>
                <li>Comprometimento com o cliente</li>
                <li>Inovação com propósito</li>
                <li>Colaboração e respeito</li>
                <li>Alta performance com integridade</li>
                <li>Paixão por vender e transformar vidas</li>
              </ul>
            </div>
          </MvvCard>
        </MvvGrid>
      </MvvSection>

      <Footer />
    </Container>
  );
}
